import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Banner1 from "../../../assets/images/banner/siw-home-bg.jpg";
import Banner2 from "../../../assets/images/banner/banner-02.png";
import Banner3 from "../../../assets/images/banner/banner-03.png";
import Banner4 from "../../../assets/images/banner/banner-04.png";
import Banner5 from "../../../assets/images/banner/banner-05.png";

const heroSlides = [
  { image: Banner1, link: "" },
  { image: Banner2, price: "From SGD 150/month", link: "/wa-food-ordering" },
  { image: Banner3, price: "From SGD 150/month", link: "/wa-invoice" },
  { image: Banner4, price: "From SGD 150/month", link: "/wa-attendance" },
  { image: Banner5, price: "From SGD 150/month", link: "/wa-chatbot" },
];

const HomeHeroSlider = () => {
  const [activeHeroIndex, setActiveHeroIndex] = useState(0);

  const goNextHero = () => {
    setActiveHeroIndex((prev) => (prev + 1) % heroSlides.length);
  };

  const goPrevHero = () => {
    setActiveHeroIndex(
      (prev) => (prev - 1 + heroSlides.length) % heroSlides.length,
    );
  };

  useEffect(() => {
    const heroTimer = setInterval(goNextHero, 5000);
    return () => clearInterval(heroTimer);
  }, []);

  const currentHero = heroSlides[activeHeroIndex];

  return (
    <section className="siw-hero-slider-wrapper">
      {heroSlides.map((slide, index) => (
        <div
          key={index}
          className={`siw-hero-slide-bg ${
            index === activeHeroIndex ? "siw-hero-slide-active" : ""
          } ${index === 0 ? "siw-hero-first-slide" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
          aria-hidden="true"
        />
      ))}

      <button
        className="siw-hero-nav-btn siw-hero-prev-btn no-cursor-effect"
        onClick={goPrevHero}
      >
        ‹
      </button>

      <button
        className="siw-hero-nav-btn siw-hero-next-btn no-cursor-effect"
        onClick={goNextHero}
      >
        ›
      </button>

      <div className="siw-hero-content-area p_relative">
        <div className="auto-container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <div className="siw-hero-content-box" key={activeHeroIndex}>
                {currentHero.title && <h1>{currentHero.title}</h1>}

                {currentHero.price && currentHero.link && (
                  <div className="siw-hero-price-box">
                    <h3>{currentHero.price}</h3>

                    <Link
                      to={currentHero.link}
                      className="theme-btn theme-btn-one siw-hero-small-btn"
                    >
                      View Details
                    </Link>
                  </div>
                )}
              </div>
            </div>

            <div className="col-lg-5 col-md-12"></div>
          </div>

          <div className="siw-hero-dots">
            {heroSlides.map((_, index) => (
              <button
                key={index}
                className={
                  index === activeHeroIndex ? "siw-hero-dot-active" : ""
                }
                onClick={() => setActiveHeroIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeHeroSlider;
